module.exports = __webpack_public_path__ + "static/media/js_register_banner.dc67cc36.jpg";